import surf from '../assets/surf.jpg'
import escalada from '../assets/escalada.jpg'
import skate from '../assets/skate2.jpg'
import ingles from '../assets/ingles.JPG'
import robotica from '../assets/robotica.jpg'
import prog from '../assets/prog.JPG'

export const activity = [
  {
    image: escalada,
    title: "Escalada",
    description: "As crianças da favela já escalam muros, árvores e lajes, brincando e correndo atrás de pipas, a escalada já está intrínseca em seus DNAS. Nosso objetivo é valorizar essas habilidades, proporcionando a eles acesso democratizado ao esporte, com boa infraestrutura, segurança e técnica. "
  },
  {
    image: robotica,
    title: "Robótica",
    description: "Na favela existe a cultura da “gambiarra”, habilidade de criar e recriar soluções com o que tiver de material disponível, mesmo que escasso. Apresentando às crianças e jovens o universo do Maker, damos novos significados para objetos que seriam descartados e jamais reutilizados, unindo tecnologia e sustentabilidade com o potencial intrínseco da cultura local."
  },
  {
    image: prog,
    title: "Programação",
    description: "Oficina que permite com que dessa vez a Favela saia na frente, qualificando e formando jovens da favela em programadores, antecipando uma necessidade do mercado de trabalho nessa área, que está em acelerada expansão, colocando a favela no cenário de captação de profissionais nesse segmento."
  },
/*   {
    image: "https://i0.wp.com/pranchanova.com/wp-content/uploads/2019/12/surfing-2212948_1920.jpg?resize=1024%2C590&ssl=1g",
    title: "Formação social emocional",
    description: "Entendemos que o desenvolvimento sócio emocional deveria ter um espaço nas nossas construções enquanto seres humanos desde crianças, mas não é a realidade, muito menos na favela. E considerando que a inserção no mercado de trabalho é um grande desafio na vida dos jovens, através desse programa, nosso objetivo é dar apoio o emocional desses alunos, através de dinâmicas, mentorias e acompanhamento psicoterapêutico, empoderando-os para um melhor aproveitamento deles no mercado e na vida."
  }, */
  {
    image: surf,
    title: "Surf",
    description: "Por ser um esporte que sua única possibilidade prática é no mar, o surf já quebra várias barreiras, carregando por si só uma miscigenação entre praticantes de diferentes classes sociais. O que fazemos é apenas dar as ferramentas necessárias para que as crianças e os jovens da favela possam praticar com qualidade e segurança, conectando-os à natureza e aos seus próprios oceanos internos."
  },
  {
    image: skate,
    title: "Skate",
    description: "O Skate sempre esteve presente na cultura urbana de nossa cidade, considerando por muito tempo um esporte de “ jovens rebeldes”, agora é um esporte olímpico. Com a essência da rua e a cultura de resistência e resiliência desse esporte, o enxergamos como uma potente ferramenta de transformação social para a favela."
  },
  {
    image: ingles,
    title: "Inglês",
    description: "Queremos dar mais voz à nova geração da favela e ampliar suas visões de mundo, para que possam agir discursivamente e ocupar papéis de participação mais ativa na sociedade, reconhecendo suas próprias culturas por meio de um maior conhecimento das culturas de outros povos."
  },
];